import React from 'react';

import CheckBox from '@mui/material/Checkbox';
import MenuItem from '@mui/material/MenuItem';
import MenuList from '@mui/material/MenuList';
import Typography from '@mui/material/Typography';

import StyledPopover from '../../../common/components/StyledPopover';
import { UserFilterOption } from '../../constants/FilterOptions';
import MenuOption from '../../types/MenuOption';

import './CheckboxMenu.scss';

interface Props {
  handleClose: () => void;
  handleSelection: (
    option: MenuOption<UserFilterOption>,
    checked: boolean
  ) => void;
  options: MenuOption<UserFilterOption>[];
  anchorEl: HTMLButtonElement | null;
  open: boolean;
  id?: string;
}

const UserFilterCheckboxMenu: React.FC<Props> = ({
  handleClose,
  handleSelection,
  anchorEl,
  open,
  id,
  options,
}) => {
  return (
    <StyledPopover
      anchorEl={anchorEl}
      open={open}
      handleClose={handleClose}
      id={id}
    >
      <MenuList>
        {options.map((option) => {
          return (
            <MenuItem
              onClick={() => handleSelection(option, !option.selected)}
              key={option.item}
            >
              <CheckBox
                inputProps={{ 'aria-label': 'controlled' }}
                checked={option.selected}
                onChange={(
                  event: React.ChangeEvent<HTMLInputElement>,
                  checked: boolean
                ) => handleSelection(option, checked)}
              />
              <Typography color='text.primary'>{option.item}</Typography>
            </MenuItem>
          );
        })}
      </MenuList>
    </StyledPopover>
  );
};

export default UserFilterCheckboxMenu;
